import { render, staticRenderFns } from "./IngresoEdit.vue?vue&type=template&id=cfcb48fc&scoped=true&"
import script from "./IngresoEdit.vue?vue&type=script&lang=ts&"
export * from "./IngresoEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcb48fc",
  null
  
)

export default component.exports